'use client'
import { useContext } from 'react'
import clsx from 'clsx'

import { Link } from '@/i18n/navigation'
import ButtonWithAnchor from '@/components/atoms/ButtonWithAnchor'

import { Heading } from '@/components/atoms/Typography'

import HeaderContext from './context/HeaderContext'

import styles from './Header.module.scss'

const HeaderMenu = () => {
  const { isHomepage, menu, compressed, isOpen, isMobile, setIsOpen } =
    useContext(HeaderContext)

  const showWhen =
    isMobile !== undefined && ((!compressed && !isMobile) || isOpen)

  const handleAnchorClick = () => {
    if (!isMobile && !isOpen) return
    setIsOpen(false)
  }

  return (
    <div className={clsx(styles.headerMenu, showWhen && styles.visible)}>
      <nav>
        <ul>
          {menu.map(({ label, ...rest }) => (
            <li key={label}>
              <ButtonWithAnchor
                autoWidth
                as={rest.href && !isHomepage ? Link : 'button'}
                className={styles.headerMenuButton}
                onAnchorClick={!rest.href ? handleAnchorClick : undefined}
                {...rest}
              >
                <Heading
                  as='span'
                  size='xs'
                >
                  {label}
                </Heading>
              </ButtonWithAnchor>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}

export default HeaderMenu
